import cx from 'classnames';
import { CONTRACTOR_REPORT_TYPE, EMPLOYEE_REPORT_TYPE } from 'constants/common';

const CONTRACTOR_TABLE_HEADERS = [
  'Establishment Name*',
  'Address Line 1*',
  'Address Line 2',
  'City*',
  'State*',
  'ZIP Code*',
  'NAICS Code*',
  'Major Activity*',
  'Total Number of Employees at Establishment*',
  'Was a California Pay Data Report filed for this establishment last year?*',
  'Was an EEO-1 Report filed for this establishment last year?*',
  "Is this establishment the employer's headquarters?*",
  'Labor Contractor Name*',
  'Labor Contractor FEIN*',
  'Snapshot - Begin Date*',
  'Snapshot - End Date*',
  'Job Category*',
  'Race/Ethnicity/Sex*',
  'Pay Band*',
  'Number of Employees*',
  'Mean - Hourly Rate*',
  'Median - Hourly Rate*',
  'Total Hours*'
];

const EMPLOYEE_TABLE_HEADERS = [
  'Establishment Name*',
  'Address Line 1*',
  'Address Line 2',
  'City*',
  'State*',
  'ZIP Code*',
  'NAICS Code*',
  'Major Activity*',
  'Total Number of Employees at Establishment*',
  'Was a California Pay Data Report filed for this establishment last year?*',
  'Was an EEO-1 Report filed for this establishment last year?*',
  "Is this establishment the employer's headquarters?*",
  'Job Category*',
  'Race/Ethnicity/Sex*',
  'Pay Band*',
  'Number of Employees*',
  'Mean - Hourly Rate*',
  'Median - Hourly Rate*',
  'Total Hours*'
];

function ReportResult({
  reportType = EMPLOYEE_REPORT_TYPE,
  reportResultData
}: {
  reportType?: String;
  reportResultData: Array<Record<string, string>>;
}): JSX.Element {
  const tableHeaders =
    reportType === CONTRACTOR_REPORT_TYPE ? CONTRACTOR_TABLE_HEADERS : EMPLOYEE_TABLE_HEADERS;
  return (
    <table id="preview-data" className="w-full divide-y divide-gray-300 table-fixed">
      <thead className="bg-gray-50">
        <tr>
          {tableHeaders.map((header, id) => (
            <th
              scope="col"
              key={id}
              className={cx('px-3 py-3.5 text-left text-sm font-semibold text-gray-900', {
                'w-72': header.length >= 42,
                'w-32': header.length < 42
              })}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {reportResultData.map((row, id) => (
          <tr key={id}>
            {tableHeaders.map((header, id) => (
              <td
                key={id}
                className="whitespace-nowrap text-left py-4 px-3 text-sm text-gray-500 w-36">
                {row[header]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ReportResult;
